import { IconTypesProps } from '@/ui/components/svg/iconTypes'
import { Circle, Rect, Svg } from '@react-pdf/renderer'

const SvgStatusCritical = ({ primaryColor = '#F0F0F0' }: IconTypesProps) => (
    <Svg width="20" height="20" viewBox="0 0 24 24">
        <Circle cx="12" cy="12" r="12" fill="#D31D1A" />
        <Rect x="6" y="10.875" width="12" height="2.25" fill={primaryColor} />
    </Svg>
)

export default SvgStatusCritical
